export default abstract class AbstractAccordion<ItemsType> {
  id: string
  items: ItemsType[]
  order: string
  title: string
  abstract component: any
  
  constructor({ id, items, order, title }: Partial<AbstractAccordion<ItemsType>>) {
    this.id = id ?? ''
    this.items = items ?? []
    this.order = order ?? '-1'
    this.title = title ?? ''
  }
}
